import * as React from "react"

import { cn } from "@/lib/utils"

// lucide-react 1.x removed every brand icon (Facebook, Instagram, Twitter, ...).
// These are the last lucide 0.x renderings of the three the footer uses, kept
// local so the footer keeps its exact look. Same 24x24 stroke-based contract as
// a lucide icon, so `className="w-5 h-5"` etc. keep working.
const BrandIcon = React.forwardRef(({ className, children, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={cn("lucide", className)}
    {...props}
  >
    {children}
  </svg>
))
BrandIcon.displayName = "BrandIcon"

const Facebook = React.forwardRef(({ className, ...props }, ref) => (
  <BrandIcon ref={ref} className={cn("lucide-facebook", className)} {...props}>
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </BrandIcon>
))
Facebook.displayName = "Facebook"

const Instagram = React.forwardRef(({ className, ...props }, ref) => (
  <BrandIcon ref={ref} className={cn("lucide-instagram", className)} {...props}>
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </BrandIcon>
))
Instagram.displayName = "Instagram"

const Twitter = React.forwardRef(({ className, ...props }, ref) => (
  <BrandIcon ref={ref} className={cn("lucide-twitter", className)} {...props}>
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
  </BrandIcon>
))
Twitter.displayName = "Twitter"

export { Facebook, Instagram, Twitter }
